<template>
    <!-- //ROUTER IF MOBILE -->
  <ion-content class="d-flex wrapper" v-if="isMobile" >
      <!-- <NavBar /> -->
      <div class="block block__commercial">
        <SidebarSearch class="desktop"/>
          <transition  
            name="fade"
          >
            <router-view></router-view>
          </transition>
      </div>
  </ion-content> 
  <!-- //ROUTER IF MOBILE -->

  <!-- //ROUTER IF DESKTOP -->
  <section class="d-flex wrapper" v-else>
      <SidebarSearch />
      <div class="block block__commercial">
        <div>
          <transition  
            name="fade"
          >
            <router-view></router-view>
          </transition>
        </div>
      </div>
  </section> 
  <!-- //ROUTER IF DESKTOP -->

</template>


<script>
import SidebarSearch from '../../module/sidebar/SidebarSearch'
import CatMixin from './CatMixin'
// import NavBar from '../../module/Navbar'

export default {
  name:"commercials",
    components:{
        SidebarSearch,
        // NavBar
    },  
    mixins: [
      CatMixin
    ],
  created(){
    window.addEventListener('wheel', this.handleScroll);
  },
  activated() {
    window.addEventListener('wheel', this.handleScroll);
  },
  deactivated() {
    window.removeEventListener('wheel', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('wheel', this.handleScroll);
  },
  methods:{
    handleScroll (event) {
      var container = this.$el.querySelector(".block__commercial");
      if (container){
        container.scrollTop += event.deltaY;
      }

      container = this.$el.querySelector(".tab-pane.active");
      if (container){
        container.scrollTop += event.deltaY;
      }

      container = this.$el.querySelector(".column-middle-parent");
      if (container){
        container.scrollTop += event.deltaY;
      }
    }
  }
};
</script>
